import thumbnail from './barchart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.barchart.title',
  thumbnail,
  icon: 'fa-chart-bar',
  id: 'bar',
  categories: ['categories.correlations'],
  description: 'global.section.chartselection.barchart.description',
  code: '',
  tutorial: '',
};
